<template>
  <div class="empty c:col-center">
    <img src="@/assets/icons/empty.svg" alt="" />
    <p>{{ text }}</p>
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: "",
    },
  },
};
</script>
<style lang="less">
.empty {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 0;
  pointer-events: none;

  img {
    width: 100/40rem;
    height: auto;
  }

  p {
    text-align: center;
    color: #909090;
    font-size: 14px;
    margin-top: 10px;
  }
}
</style>
